
//- Uility functions declaration
window.doWhenInViewport = function doWhenInViewport(el, callback, threshold = 0) {
    const options = {
        root: null,
        threshold: threshold
    };

    let observer = new IntersectionObserver(callback, options);
    observer.observe(el);
}

//- General
/**
 * Highlight keywords wrapped in <mark> tags when it enters the viewport
 */
if ($('body').hasClass('hasHighlightKeywords')) {
    $('mark').each(function() {
        const currentEl = $(this);
        let isShown = false;
        window.doWhenInViewport($(this)[0], function(entries, observer) {
            if (entries[0].isIntersecting && !isShown) {
                isShown = true;
                $(currentEl).addClass('inViewport');
            }
        });
    });
}